import React from 'react';
import withIcon from '../utilities/withIcon';

const IconMore = () => {
  return (
    <g>
      <circle cx="1.9236" cy="8" r="1.8436" />
      <circle cx="8" cy="8" r="1.8436" />
      <circle cx="14.0764" cy="8" r="1.8436" />
    </g>
  );
};

export default withIcon(IconMore);
